import VGSearch from "./search";
import {listener} from "../../../../../modules/vegas/js/util";
import {timeout} from "../../../vg/modules/timeout";

let searchMobile = new VGSearch();
searchMobile.setContainer('#mobile-search-results');
searchMobile.setRequestParams({mobile: true});

listener('input click', '#form-search-mobile [data-vg-toggle="search"]', function (el, e) {
	timeout('mobile-search', 300, () => {
		searchMobile.search(el.value)
	});
});

listener('vg.sidebar.show', '#sidebar-search', (el, e) => {
	searchMobile.search(
		document.querySelector('#form-search-mobile [data-vg-toggle="search"]').value
	);
})

document.addEventListener('keyup', (e) => {
	if (e.key === "Escape") {
		new VGSearch().close();
	}
});

/*window.addEventListener('mouseup', e => {
	if (e.target.closest('.search-advanced--wrapper-content')) return false;

	if (!e.target.closest('.search-advanced--wrapper-content') || e.target !== document.querySelector('input[name="search"]')) {
		new VGSearch().close();
	}
});*/

/*
let $searchKeys = document.querySelectorAll('[data-keysearch]');
if ($searchKeys.length) {
	for (let key of $searchKeys) {
		key.onclick = () => {
			let $container = document.getElementById('search-advanced'),
				input = $container.querySelector('input');

			if (input) {
				input.value = this.dataset.keysearch;
				input.closest('form').submit();
			}

			return false;
		}
	}
}
*/
